import { createReducer } from "reduxsauce";
import ReducerRegister from "../../../../ReducerRegister";
import { ActionTypes } from "../../../../actionTypes/screens/admin/agent/useraccount/EditActionTypes";
import EditService from "../../../../../services/screens/admin/agent/useraccount/EditService"
import AsyncActionReducers from "../../../../AsyncActionReducers";
import RegisterService from "../../../../../services/screens/account/RegisterService";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.agent.useraccount.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, vo });

            EditService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveUserAccountAsync: (vo) => {
        return (dispatch) => {
            dispatch({ type: ActionTypes.SAVE_USER_ACCOUNT_ASYNC, vo });

            EditService.saveUserAccount(vo,
                response => {
                    dispatch(Actions.saveUserAccountSuccess(response));
                },
                error => {
                    dispatch(Actions.saveUserAccountFailure(error));
                }
            );
        };
    },

    saveUserAccountSuccess: data => ({
        type: ActionTypes.SAVE_USER_ACCOUNT_SUCCESS,
        parentType: ActionTypes.SAVE_USER_ACCOUNT_ASYNC,
        postReducer: saveUserAccountSuccessPostReducer,
        data
    }),

    saveUserAccountFailure: error => ({
        type: ActionTypes.SAVE_USER_ACCOUNT_FAILURE,
        parentType: ActionTypes.SAVE_USER_ACCOUNT_ASYNC,
        error
    }),

    getAllCountryCodeAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC });

            RegisterService.getAllCountryCode(
                response => {
                    dispatch(Actions.getAllCountryCodeSuccess(response));
                },
                error => {
                    dispatch(Actions.getAllCountryCodeFailure(error));
                }
            );
        };
    },

    getAllCountryCodeSuccess: data => ({
        type: ActionTypes.GET_ALL_COUNTRY_CODE_SUCCESS,
        parentType: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC,
        postReducer: getAllCountryCodeSuccessPostReducer,
        data
    }),

    getAllCountryCodeFailure: error => ({
        type: ActionTypes.GET_ALL_COUNTRY_CODE_FAILURE,
        parentType: ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC,
        error
    }),
};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    userAccount: null,
    countryCodeList: null,
};

/* ------------- Reducers ------------- */
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, userAccount: data.userAccount };
};

const saveUserAccountSuccessPostReducer = (state, { data }) => {
    return { ...state, addUserType: data.addUserType, referralCodeAsTeacher: data.referralCodeAsTeacher, email: data.email, initialPassword: data.initialPassword };
};

const getAllCountryCodeSuccessPostReducer = (state, { data }) => {
    return { ...state, countryCodeList: data };
};

/* ------------- Hookup Reducers To Types ------------- */

const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_USER_ACCOUNT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_USER_ACCOUNT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_USER_ACCOUNT_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.GET_ALL_COUNTRY_CODE_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };